




















































































































import { Component, Vue, Prop } from 'vue-property-decorator';
// import { TransactionHttp } from 'nem2-sdk';
// import { PostMessage, ReviewMessage, Message } from '@luxtag/luxtag-sdk-ts';
// import { ApostillePublicAccount } from 'apostille-library';
import DynamicDivider from '@/components/DynamicDivider.vue';
import UploadImgsBtn from '@/components/certificate/UploadImgsBtn.vue';
import UploadImageItem from '@/components/certificate/UploadImageItem.vue';
// import { PublicAccount, NetworkType, Account } from 'nem2-sdk';
import { error } from 'util';

@Component({
  components: {
    DynamicDivider,
    UploadImgsBtn,
    UploadImageItem,
  },
})
export default class UpdateField extends Vue {
    @Prop({ default: false }) public disableTabs!: boolean;

    public memo: string = '';
    public review: string = '';
    public rating: number = 0;
    public tabs: number | null = 0;
    public updateFieldFocus = false;

    public files = [];

    public imgs = [
        'https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg',
        'https://cdn.vuetifyjs.com/images/carousel/sky.jpg',
        'https://cdn.vuetifyjs.com/images/carousel/bird.jpg',
        'https://cdn.vuetifyjs.com/images/carousel/planet.jpg',
    ];

    public postLoading = false;

    public async post() {
        if (this.tabs === 0) {
            this.postMemo();
            await new Promise((resolve, reject) => setTimeout(resolve, 500));
            this.updateFieldFocus = false;
        } else if (this.tabs === 1) {
            this.postReview();
            await new Promise((resolve, reject) => setTimeout(resolve, 500));
            this.updateFieldFocus = false;
        }
    }

    public postMemo() {
        // TODO: change this.imgs into the url of uploaded img
        // const memo = new PostMessage(this.memo, this.imgs);
        // this.sendUpdate(memo);
        // this.resetMemo();
    }

    public postReview() {
        // const review = new ReviewMessage(this.rating, this.review);
        // this.sendUpdate(review);
        // this.resetReview();
    }

    public removeImg(file: any) {
        (this.$refs.uploadButton as HTMLFormElement).$refs.upload.remove(file);
    }

    public sendUpdate(message: any) {
        // const signer = Account.createFromPrivateKey(this.$store.getters.getUserPK, NetworkType.MIJIN_TEST);
        // const assetAccount = PublicAccount.createFromPublicKey(
        //     this.$route.params.certificateId,
        //     NetworkType.MIJIN_TEST,
        // );

        // const apostille = new ApostillePublicAccount(assetAccount);

        // const updateTx = apostille.update(message.toString());
        // const signedTx = apostille.sign(updateTx, signer);

        // const txHttp = new TransactionHttp(this.$store.getters.getEndpoint);
        // txHttp.announce(signedTx)
        //     .subscribe((res) => {
        //         console.log(res);
        //     }, (err) => {
        //         console.log(`error ${err}`);
        //     });
    }

    public getNameFromUrl(url: string): string {
        const firstSplit = url.split('/').pop();
        if (firstSplit) {
            const secondSplit = firstSplit.split('#')[0].split('?')[0];
            if (secondSplit) {
                return secondSplit;
            } else {
                return firstSplit;
            }
        } else {
            return '';
        }
    }

    private reset() {
        this.resetMemo();
        this.resetReview();
    }

    private resetMemo() {
        this.memo = '';
        this.imgs = [];
    }

    private resetReview() {
        this.review = '';
        this.rating = 0;
    }

    get postDisabled() {
        if (this.tabs === 0) {
            if (!!this.memo.trim() || this.imgs.length > 0) {
                // if memo not empty or there is atleast one img
                return false;
            } else {
                return true;
            }
        } else if (this.tabs === 1) {
            if (!!this.review.trim() && this.rating > 0) {
                // if review is not empty and rating > 0
                return false;
            } else {
                return true;
            }
        } else {
            return true;
        }
    }

    get isMemoEmpty() {
        return !!this.memo;
    }
}
